import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PaginatorModule } from 'primeng/paginator';

@Component({
  selector: 'app-primeng-paginator',
  standalone: true,
  imports: [CommonModule, PaginatorModule],
  templateUrl: './primeng-paginator.component.html',
  styleUrl: './primeng-paginator.component.scss'
})
export class PrimengPaginatorComponent {
  @Input() totalRecords = 0; // Total records from server
  @Input() rows = 10; // Items per page
  @Input() currentPage = 1; // Current page
  @Input() rowsPerPageOptions: number[] = [10, 20, 50]; // Page size options
  @Input() showRowsPerPageOptions = false; // Toggle visibility of rowsPerPageOptions
  @Output() pageChange = new EventEmitter<{ page: number; rows: number }>();

  onPageChange(event: any): void {
    this.pageChange.emit({ page: event.page + 1, rows: event.rows });
  }
}
